export const TIPOS_DOCUMENTO = {
  DNI: 'DNI',
  PASAPORTE: 'PASAPORTE'
};

export const TIPO_DOCUMENTO_A_PEDIR = {
  DNI: 'DNI',
  PASAPORTE: 'PASAPORTE',
  DNI_AND_PASAPORTE: 'DNI_AND_PASAPORTE',
  DNI_OR_PASAPORTE: 'DNI_OR_PASAPORTE'
};

export const COMERCIAL_ID_PARAM = 'comercialId';
